import { GetterTree } from "vuex";

import { HomeState } from "../types";

const getters: GetterTree<HomeState, any> = {
  getShouldPromptCancellation: (state) => state.isPromptingForCancel,
};

export default getters;
